import { ReactComponent as BottomCardIMG } from "../../Icons/bottom-cart.svg";
import ClickOutSideDiv from "./ClickOutSideDiv";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import ProductCard from "../homeProduct/ProductCard";
import { useTranslation } from "react-i18next";
import { currencyOptions } from "../../staticData/options";
import { useNavigate } from "react-router-dom";
import PromoModal from "./PromoModal";
import QRcode from "./QRcodeModal";
import { useAuth } from "../../../items/AuthProvider";

import Swal from "sweetalert2";
import request from "../../../../services/Request";

function BottomCard(props) {
  const { user, setRefresh, refresh } = useAuth();
  const history = useNavigate();
  const { cart, setShowCart, showCart, langs, remove, changePrice, promoRef } =
    props;
  const { t } = useTranslation();
  const machineData = JSON.parse(localStorage.getItem("machine"));
  const machineID = machineData._id;
  const tax = machineData.tax;
  const tax_rate = machineData.tax_rate;
  let symbol = JSON.parse(localStorage.getItem("machine"))?.currency?.symbol;
  const testMode = localStorage.getItem("testMode");
  symbol = symbol ? symbol : "$";
  let promoData = [];
  let prods = [];
  try {
    prods = JSON.parse(localStorage.getItem("products"));
    promoData = JSON.parse(localStorage.getItem("promo"));
  } catch (e) {}

  console.log("promoData", promoData);

  const [mainL, setMainL] = useState("en-US");
  const [products, setProducts] = useState(<div></div>);

  const [showPromo, setShowPromo] = useState(false);
  const [loading, setLoading] = useState(false);

  const [show, setShow] = useState(false);

  const [showQR, setShowQR] = useState(false);
  const [qrData, setQRData] = useState("");

  const [nowsubtotal, setSubtotal] = useState(0);
  const [nowdiscount, setDiscount] = useState(0);
  const [totalPrice, setTotal] = useState(0);
  const [finalTax, setTax] = useState(0);

  useEffect(() => {
    const discount = cart.reduce((totalCost, item) => {
      if (item?.buyX > 1) {
        if (item.quantity === 1) {
          return totalCost;
        }
        if (item.quantity > 1) {
          if (item.quantity % item.buyX === 0) {
            if (item.percentage) {
              return (
                totalCost +
                parseFloat(
                  (
                    item.price * item.quantity -
                    item.discountedPrice * item.quantity
                  ).toFixed(2)
                )
              );
            } else {
              return (
                totalCost +
                parseFloat(
                  (
                    item.discount * Math.trunc(item.quantity / item.buyX)
                  ).toFixed(2)
                )
              );
            }
          } else {
            if (item.quantity < item.buyX) return totalCost;
            else {
              if (item.percentage == true) {
                return (
                  totalCost +
                  parseFloat(
                    (
                      item.price * item.quantity -
                      item.discountedPrice * item.quantity
                    ).toFixed(2)
                  )
                );
              } else {
                return (
                  totalCost +
                  parseFloat(
                    (
                      item.discount * Math.trunc(item.quantity / item.buyX)
                    ).toFixed(2)
                  )
                );
              }
            }
          }
        } else return totalCost;
      } else if (item.buyX === 1) {
        if (item.discount != 0)
          return (
            totalCost +
            parseFloat((item.price - item.discountedPrice).toFixed(2))
          );
        else return totalCost;
      } else {
        if (item.discount > 0) {
          return (
            totalCost +
            parseFloat(
              ((item.price - item.discountedPrice) * item.quantity).toFixed(2)
            )
          );
        } else {
          return totalCost;
        }
      }
    }, 0);

    setDiscount(discount);

    // const subtotal = cart.reduce((totalCost, item) => {
    //   return (totalCost += parseFloat((item.price * item.quantity).toFixed(2)));
    // }, 0);

    // setSubtotal(subtotal);

    const subtotal = cart.reduce((totalCost, item) => {
      let result = 0;
      if (item?.buyX > 1) {
        if (item.quantity === 1) {
          result = item.price;
        }
        if (item.quantity > 1) {
          if (item.quantity % item.buyX === 0) {
            if (item.percentage) {
              result =
                parseFloat((item.price * item.quantity).toFixed(2)) -
                parseFloat(
                  (item.price * item.quantity * item.discount).toFixed(2)
                );
            } else {
              result =
                parseFloat((item.price * item.quantity).toFixed(2)) -
                parseFloat((item.discount * item.pQuantity).toFixed(2));
            }
          } else {
            if (item.quantity < item.buyX) {
              result = parseFloat((item.price * item.quantity).toFixed(2));
            } else {
              if (item.percentage == true) {
                result =
                  parseFloat((item.price * item.quantity).toFixed(2)) -
                  parseFloat(
                    (item.price * item.quantity * item.discount).toFixed(2)
                  );
              } else {
                result = parseFloat(
                  (
                    item.price * item.buyX * item.pQuantity -
                    item.discount +
                    item.price * (item.quantity - item.buyX * item.pQuantity)
                  ).toFixed(2)
                );
              }
            }
          }
        }
      } else if (item.buyX === 1) {
        result = parseFloat(
          (item.discountedPrice + item.price * (item.quantity - 1)).toFixed(2)
        );
      } else {
        result = parseFloat((item.discountedPrice * item.quantity).toFixed(2));
      }

      // apply tax
      if (!tax && typeof tax_rate?.typeA === "number") {
        // console.log('result', result);
        // console.log('tax_rate', tax_rate);
        if (item.tax_type === "1") {
          item.tax = parseFloat(
            (
              (parseFloat(result) * tax_rate.typeB) /
              item.quantity /
              100
            ).toFixed(2)
          );
        } else if (item.tax_type === "2") {
          item.tax = parseFloat(
            (
              (parseFloat(result) * tax_rate.typeC) /
              item.quantity /
              100
            ).toFixed(2)
          );
        } else if (item.tax_type === "3") {
          item.tax = parseFloat(
            (
              (parseFloat(result) * tax_rate.typeD) /
              item.quantity /
              100
            ).toFixed(2)
          );
          // typeA is the default tax rate
        } else {
          item.tax = parseFloat(
            (
              (parseFloat(result) * tax_rate.typeA) /
              item.quantity /
              100
            ).toFixed(2)
          );
        }
      } else {
        // console.log('tax');
        item.tax = parseFloat(
          ((parseFloat(result) * tax) / item.quantity / 100).toFixed(2)
        );
      }
      return totalCost + result;
    }, 0);

    setSubtotal(subtotal);

    let finalTax = cart.reduce((totalCost, item) => {
      return totalCost + item.tax * item.quantity;
    }, 0);

    setTax(finalTax);

    let snewubtotal = parseFloat(subtotal.toFixed(2));
    let total = snewubtotal + finalTax;
    total = parseFloat(total.toFixed(2));

    setTotal(total);
  }, [cart]);

  useEffect(() => {
    if (showPromo) {
      promoRef.current = true;
    } else {
      promoRef.current = false;
    }
  }, [showPromo]);

  useEffect(() => {
    const mycoockie = Cookies.get("i18next");
    if (mycoockie === "fr") {
      setMainL("fr-CA");
    } else if (mycoockie === "es") {
      setMainL("es-US");
    }
  }, []);

  useEffect(() => {
    // console.log(cart);
    if (cart.length === 0) {
      setShowCart(false);
    }
  }, [cart]);

  const createOrder = () => {
    // setRefresh(!refresh);
    console.log("createOrder", user);
    if (
      user?.add_to_cart?.products?.length > 0 &&
      user?.add_to_cart?.created_by_admin
    ) {
      Swal.fire({
        icon: "info",
        title: "You have products in your cart",
        text: "Please clear your cart to create an order",
        confirmButtonText: "OK",
      }).then(() => {
        history(`/pendingorder`);
      });
    } else {
      //formact Products
      let prods = [];
      cart.forEach((item) => {
        for (let i = 0; i < item.quantity; i++) {
          prods.push({
            id: {
              _id: item._id,
              name: item.name,
              price: item.price,
              upc: item.upc,
            },
          });
        }
      });

      request({
        method: "post",
        url: `/clientUser/clientUserAddToCart`,
        data: {
          _id: user?._id,
          machine: {
            _id: machineData?._id,
            name: machineData?.name,
            description: machineData?.description,
          },
          products: prods,
        },
      }).then((res) => {
        Swal.fire({
          icon: "success",
          title: "Order created successfully",
          confirmButtonText: "OK",
        }).then(() => {
          setRefresh(!refresh);
          history(`/pendingorder`);
        });
      });
    }
  };

  function getSubTotal(cart) {
    return nowsubtotal.toLocaleString(mainL, currencyOptions);
  }

  function getDiscountTotal(cart) {
    return nowdiscount.toLocaleString(mainL, currencyOptions);
  }

  function getTotal(cart) {
    return totalPrice.toLocaleString(mainL, currencyOptions);
  }

  function getFinalTax(cart) {
    return finalTax.toLocaleString(mainL, currencyOptions);
  }

  function promoCode() {
    setShowPromo(true);
  }

  useEffect(() => {
    let symbol = JSON.parse(localStorage.getItem("machine"))?.currency?.symbol;
    symbol = symbol ? symbol : "$";

    const prods = cart.map((prod, i) => {
      // console.log(prod);
      // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.image}/${prod.referTo}`;
      const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.image}/${prod.referTo}`;

      prod.name = prod.title;
      return (
        <ProductCard
          remove={remove}
          langs={langs}
          mainL={mainL}
          symbol={symbol}
          cart={props.cart}
          alterquantity={props.alterquantity}
          add={props.add}
          decreStock={props.decreStock}
          prod={prod}
          image={url}
          key={i}
          isCart={true}
          twoLine={true}
        />
      );
    });
    // console.log(cart);
    setProducts(prods);
  }, [cart]);

  if (showCart) {
    return (
      <ClickOutSideDiv
        setShowCart={setShowCart}
        showPromo={showPromo}
        showQR={showQR}
      >
        {promoData?.length > 0 && (
          <PromoModal
            products={prods}
            changePrice={changePrice}
            total={totalPrice}
            show={showPromo}
            setShow={setShowPromo}
            onHide={() => {
              setShowPromo(false);
            }}
          />
        )}

        <QRcode
          qrData={qrData}
          show={showQR}
          setShow={setShowQR}
          onHide={() => {
            setShowQR(false);
          }}
        />

        <div className="shopping-cart ">
          <div className="shopping-cart-left">
            <div className="cart-title-div">
              <div className="cart-title"> {t(`Your Cart`)}</div>
            </div>

            <div className="cart-home-products">{products}</div>
          </div>
          <div className="shopping-cart-right">
            <div>
              {cart && cart.length > 0 && (
                <div
                  id="check-out-button"
                  className="view-more-button cart-checkout-button"
                  onClick={createOrder}
                >
                  {t(`Create Order`)}
                </div>
              )}
              {promoData?.length > 0 && (
                <div
                  className="view-more-button cart-checkout-button"
                  onClick={promoCode}
                >
                  {t(`PROMO CODE`)}
                </div>
              )}
            </div>

            {/* <div className="promo-code cart-total-text">Promo Code </div> */}
            {/* <div className="cart-total-text cart-subtotal" style={{ marginTop: '188px' }}> */}
            <div
              className="cart-total-text cart-subtotal"
              style={
                promoData?.length > 0
                  ? { marginTop: "130px" }
                  : { marginTop: "220px" }
              }
            >
              <p>
                <span className="cart-left-text">{t(`Sub total`)}: </span>
                <span className="cart-right-text">
                  {mainL != "fr-CA" && symbol}
                  {getSubTotal(props.cart)}
                  {mainL == "fr-CA" && symbol}
                </span>
              </p>
            </div>
            <div className="cart-total-text">
              <p>
                <span className="cart-left-text">{t(`Discount`)}: </span>
                <span className="cart-right-text">
                  {mainL != "fr-CA" && symbol}
                  {getDiscountTotal(props.cart)}
                  {mainL == "fr-CA" && symbol}
                </span>
              </p>
            </div>
            <div className="cart-total-text">
              <p>
                <span className="cart-left-text">{t("Tax")}: </span>
                <span className="cart-right-text">
                  {mainL != "fr-CA" && symbol}
                  {getFinalTax(props.cart)}
                  {mainL == "fr-CA" && symbol}
                </span>
              </p>
            </div>
            <div className="cart-totalfinal-text">
              <p>
                <span className="cart-left-text">{t(`Total`)}:</span>
                <span className="cart-right-text">
                  {mainL != "fr-CA" && symbol}
                  {getTotal(props.cart)}
                  {mainL == "fr-CA" && symbol}
                </span>
              </p>
            </div>
          </div>
        </div>
      </ClickOutSideDiv>
    );
  } else {
    return (
      cart.length > 0 && (
        <div
          className="green-cart-bottom"
          onClick={() => {
            setShowCart(true);
          }}
        >
          <BottomCardIMG className="bottomcartIMG" />
        </div>
      )
    );
  }
}
export default BottomCard;
